import {Component, InputComponent, LockAxis, Object3D, PhysXComponent} from "@wonderlandengine/api";
import {property} from "@wonderlandengine/api/decorators.js";
import { PlayerMovementHandler } from "./player-movement-handler.js";
import { UserSettingsStore } from "./utils/user-settings-store.js";

/**
 * smooth-rotate
 */
export class SmoothRotate extends Component {
	static TypeName = "smooth-rotate";
    static instances: Set<SmoothRotate> = new Set<SmoothRotate>();

    @property.bool()
    activeInXR: boolean = false;

    @property.bool()
    activeOutXR: boolean = false;

    @property.object()
    playerObject: Object3D | null = null; //must have a player-movement-handler component

	@property.object({required: true})
	private controller?: Object3D;

	@property.float(90)
	private rotationSpeed: number = 90.0; // degrees per second

	@property.float(0.1)
	private lowThreshold = 0.1;

	private input?: InputComponent;
    private inXR = false;
	private _playerMovementHandler: PlayerMovementHandler | null = null;

	init() {
		SmoothRotate.instances.add(this);
	}

	onDestroy() {
		SmoothRotate.instances.delete(this);
	}

	public getRotationSpeed(): number {
		return this.rotationSpeed;
	}

	public setRotationSpeed(speed: number): void {
		const safeSpeed = Number.isFinite(speed) ? Math.max(0, speed) : this.rotationSpeed;
		this.rotationSpeed = safeSpeed;
	}

	public setControlActive(active: boolean): void {
		this.active = active;
	}

	start() {
		const persistedSpeed = UserSettingsStore.getNumber(UserSettingsStore.Keys.SmoothRotationSpeed);
		if (persistedSpeed != null) {
			this.setRotationSpeed(persistedSpeed);
		}

		const persistedMode = UserSettingsStore.getRotationMode('snap');
		this.setControlActive(persistedMode === 'smooth');

		const tempInput = this.controller?.getComponent(InputComponent);
		if (!tempInput) {
			throw new Error(
				"The smooth-rotate component requires an input component on controller object",
			);
		}
		this.input = tempInput;

        const tempPlayerMove = this.playerObject?.getComponent(PlayerMovementHandler);
        if (!tempPlayerMove) {
            throw new Error(
                "The smooth-rotate component requires a player-movement-handler component on playerObject",
            );
        }

		this._playerMovementHandler = tempPlayerMove;
		this.input = tempInput;

        this.engine.onXRSessionStart.add(this.onXRSessionStart.bind(this));
        this.engine.onXRSessionEnd.add(this.onXRSessionEnd.bind(this));
	}

    onXRSessionStart (session : XRSession) {
        this.inXR = true;
    }

    onXRSessionEnd () {
        this.inXR = false;
    }

	update(delta: number) {
		if (!this.active) {
			return;
		}

		if ((this.inXR && this.activeInXR) || (!this.inXR && this.activeOutXR)) {
			if (!this.input?.xrInputSource?.gamepad?.axes?.length) {
				return;
			}
			const currentAxis = this.input.xrInputSource.gamepad.axes[2];
			if (Math.abs(currentAxis) < this.lowThreshold) {
				return;
			}

			const yawRate = -currentAxis * this.rotationSpeed;
			if (this._playerMovementHandler) {
				this._playerMovementHandler.requestYawDeltaDeg(yawRate);
			}
		}
	}
}

